module.exports = __webpack_public_path__ + "img/BMEL.d703f88e.png";